function methodsAfterQtyUpdate() {
  const pixTotalId = document.getElementById("pix-price");
  const cartaoTotalId = document.getElementById("cartao-price");
  let cartaoPricePr = 0;
  let pixPricePr = 0;
  const cartItemsPr = document.querySelectorAll(".cart-item");
  cartItemsPr.forEach(item => {
    cartaoPricePr = cartaoPricePr + Number(item.dataset.cartaoPrice);
    pixPricePr = pixPricePr + Number(item.dataset.pixPrice);
  })
  cartaoTotalId.innerText = (Number(cartaoPricePr) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
  pixTotalId.innerText = (Number(pixPricePr) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
}

CartDrawer.prototype.renderContents = function (parsedState) {
  this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(sectionElement) {
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  
  if (document.querySelector(".rs-diverse-notice")) {
    document.querySelector(".drawer__footer .cart__ctas")?.remove();
    this.methodsHandler();
    if (window.rsShowsAlert) window.alert("CHECKOUT INDISPONÍVEL - Selecione somente uma forma de pagamento");
  }
}

CartDrawer.prototype.methodsHandler = function () {
  const methodButtons = document.querySelectorAll(".rs-method");
  const cartItems = document.querySelectorAll(".cart-drawer .cart-item");
  const pixTotal = document.getElementById("pix-price");
  const cartaoTotal = document.getElementById("cartao-price");
  let cartaoPrice = 0;
  let pixPrice = 0;
  
  cartItems.forEach(item => {
    cartaoPrice = cartaoPrice + Number(item.dataset.cartaoPrice);
    pixPrice = pixPrice + Number(item.dataset.pixPrice);

    cart[item.dataset.varId] = Number(item.querySelector(".quantity__input").value);
    
    
  })
  cartaoTotal.innerText = (Number(cartaoPrice) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
  pixTotal.innerText = (Number(pixPrice) / 100.00).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })

  methodButtons.forEach(met => {
    met.addEventListener("click", e => {
      const method = e.currentTarget.id;
      
      let updates = {
      };
      cartItems.forEach(item => {
        const quantity = Number(item.querySelector(".quantity__input").value);
        const SKU = item.dataset.sku;
        const varId = item.dataset.varId;
        const altId = item.dataset.altId;
        let currentItemChanges = false;
        let numberToAdd = 0;
        
        if (SKU.includes('-2')) {
          currentItemChanges = method == 'cartao' ? false : true;
        } else {
          currentItemChanges = method == 'cartao' ? true : false;
        }
        
        if (currentItemChanges) {
          updates[varId] = 0;
          updates[altId] = cart[altId] ? quantity + cart[altId] : quantity;
        };
      })
      
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates, sections: ['cart-drawer'] })
      })
      .then(response => {
        return response.json(); 
      })
      .then(result => {
        if (result.sections['cart-drawer']) {
          const divWrapper = document.createElement('div');
          divWrapper.innerHTML = result.sections['cart-drawer'];
          document.querySelector("#shopify-section-cart-drawer .drawer__inner .cart-items").innerHTML = divWrapper.querySelector("#shopify-section-cart-drawer .drawer__inner .cart-items").innerHTML;
          document.querySelector("#shopify-section-cart-drawer .drawer__footer__inner").innerHTML = divWrapper.querySelector("#shopify-section-cart-drawer .drawer__footer__inner").innerHTML;
        }

        return result
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    })
  })
  
}

CartDrawerItems.prototype.updateQuantity = function (line, quantity, name) {
  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  });

  const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      this.renderContents(parsedState, lineItem, name);
      document.dispatchEvent(new CustomEvent('afterUpdateQuantity'));
      methodsAfterQtyUpdate()
      errors.classList.add('hidden');
    }).catch(() => {
      errors.classList.remove('hidden');
      errors.querySelector('span').textContent = window.cartStrings.error;
    }).finally(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      this.disableLoading();
    });
  
}
